import styled from 'styled-components';

import { mediaConfined, mediaWideNavless } from '@xing-com/layout-tokens';
import {
  space3XL,
  spaceL,
  spaceS,
  spaceXXL,
  xdlColorBackground,
} from '@xing-com/tokens';

import { Confirmation } from './confirmation';

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${xdlColorBackground};
  margin: ${spaceS} auto ${spaceXXL} auto;

  @media ${mediaWideNavless} {
    margin: ${space3XL} auto;
  }
`;

export const StyledSimilarJobsWrapper = styled.div`
  margin-bottom: ${spaceXXL};
`;

// Define the order of the Apply Banner in the header.
export const StyledConfirmation = styled(Confirmation)`
  order: -1;
  margin-bottom: ${spaceS};

  @media ${mediaConfined} {
    order: 0;
    margin-top: ${space3XL};
    margin-bottom: 0;
  }
`;

export const TopContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

export const TopContentRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spaceL};
`;

export const TopContentLeft = styled.div`
  display: flex;
  justify-content: flex-end;

  @media ${mediaConfined} {
    justify-content: flex-start;
  }
`;
